import { Button } from "components/atoms/Button";
import { Delete } from "components/atoms/Icon";
import NumberInput from "components/atoms/NumberInput/NumberInput";
import { Header } from "components/atoms/Typography";

export interface RevenueEffectInputsInterface {
    description: string | null;
    annualRevenue: number | null;
}

function RevenueEffectInput({
    inputs,
    setInputs,
}: {
    inputs: RevenueEffectInputsInterface | null;
    setInputs: (inputs: RevenueEffectInputsInterface | null) => void;
}) {
    if (inputs === null) {
        return (
            <div className="filter-container">
                <Button
                    type="primary"
                    onClick={() =>
                        setInputs({
                            description: null,
                            annualRevenue: null,
                        })
                    }
                >
                    + Add revenue
                </Button>
            </div>
        );
    }
    return (
        <div className="effect-container">
            <div className="effect-header">
                <Header size="medium">Revenue</Header>
                <Button onClick={() => setInputs(null)} icon={<Delete />} />
            </div>
            <Header size="small">Annual revenue</Header>
            <NumberInput
                key="revenueAnnual"
                required={false}
                value={inputs.annualRevenue || ""}
                className="filter-input"
                onChange={(e) => {
                    if (e.target.value === "") {
                        setInputs({
                            ...inputs,
                            annualRevenue: null,
                        });
                    }
                    const annualRevenue = Number(e.target.value);
                    setInputs({
                        ...inputs,
                        annualRevenue,
                    });
                }}
                placeholder="Enter annual revenue for this measure"
            />
            <Header size="small">Revenue description</Header>
            <input
                key="revenueDescription"
                required={false}
                type="text"
                value={inputs.description || ""}
                className="filter-input"
                onWheel={(e) => e.currentTarget.blur()}
                onChange={(e) => {
                    setInputs({
                        ...inputs,
                        description: e.target.value,
                    });
                }}
                placeholder="Enter annual revenue for this measure"
            />
        </div>
    );
}

export default RevenueEffectInput;
